import { render, staticRenderFns } from "./RelationIBAN.vue?vue&type=template&id=5a5fc9c3"
import script from "./RelationIBAN.vue?vue&type=script&setup=true&lang=js"
export * from "./RelationIBAN.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports